export default __webpack_public_path__ + "static/media/wow.6852d1ed.svg";